// extracted by mini-css-extract-plugin
export default {"root":"DeviceCard_root__sh0Tf"};